import Section from 'components/section-menu/Section';
import { useMemo } from 'react';
import { Control, FieldValues, useFormContext } from 'react-hook-form';
import { CustomField } from 'types/customFields';
import CustomFieldInput from './CustomFieldInput';
import { groupFieldsByHeaders } from './useCustomFields';

interface Props {
    fields: CustomField[];
    control: Control<FieldValues>;
    readonly?: boolean;
    /** Drops the mandatory flag the tenant set on each field. */
    allOptional?: boolean;
}

const CustomFields = ({ control, fields, readonly = false, allOptional = false }: Props) => {
    const groupedByHeaders = useMemo(() => groupFieldsByHeaders(fields), [fields]);
    const formContext = useFormContext();

    return (
        <>
            {groupedByHeaders.map(({ section, fields }) => (
                <Section key={`customField-${section}`} title={section} noTranslation collapsible>
                    {fields.map((field) => {
                        return (
                            <CustomFieldInput
                                {...field}
                                isMandatory={field.isMandatory && !allOptional}
                                control={control}
                                key={`customField-${section}-${field.id}`}
                                formContext={formContext}
                                readonly={readonly}
                            />
                        );
                    })}
                </Section>
            ))}
        </>
    );
};

export default CustomFields;
